import React from "react";
import { Box, Skeleton } from "@mui/material";
import { styled } from "@mui/material/styles";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Card = styled(Box)(({
  theme
}) => ({
  width: 340,
  borderRadius: 4,
  overflow: "hidden",
  boxShadow: theme.shadows[2],
  [theme.breakpoints.down("sm")]: {
    width: "min(92vw, 330px)"
  }
}));
export default function EventCardSkeleton() {
  return /*#__PURE__*/_jsxs(Card, {
    children: [/*#__PURE__*/_jsx(Skeleton, {
      variant: "rectangular",
      width: "100%",
      height: 200
    }), /*#__PURE__*/_jsxs(Box, {
      p: 2,
      children: [/*#__PURE__*/_jsx(Skeleton, {
        variant: "text",
        width: "60%",
        height: 28
      }), /*#__PURE__*/_jsx(Skeleton, {
        variant: "text",
        width: "80%",
        height: 20
      }), /*#__PURE__*/_jsx(Skeleton, {
        variant: "text",
        width: "90%",
        sx: {
          mt: 1
        }
      }), /*#__PURE__*/_jsx(Skeleton, {
        variant: "text",
        width: "70%"
      }), /*#__PURE__*/_jsxs(Box, {
        display: "flex",
        gap: 1,
        mt: 1.5,
        children: [/*#__PURE__*/_jsx(Skeleton, {
          variant: "rounded",
          width: 80,
          height: 24,
          sx: {
            borderRadius: 999
          }
        }), /*#__PURE__*/_jsx(Skeleton, {
          variant: "rounded",
          width: 60,
          height: 24,
          sx: {
            borderRadius: 999
          }
        })]
      })]
    })]
  });
}